<app-system-development-bar *ngIf="showDevelopBar"></app-system-development-bar>
<footer class="container-fluid">
    <div class="row">
      <div class="col-md-4">
          <div class="title-phone">
              SAC - WhatsApp

              <div class="box-phone d-flex align-items-center">
                <a [href]=whatsappUrl target="_blank" rel="noopener noreferrer" (click)="onWhatsAppButtonClick()">
                    <span class="material-icons">perm_phone_msg</span>
                    <p>
                        (51) 99528 0140
                    </p>
                </a>
              </div>
          </div>
      </div>
      <div class="col-md-4">
          <div class="title-phone">
              SAC - Todas as regiões do Brasil

              <div class="box-phone">
                <a href="tel:08008801900" target="_blank" (click)="onPhoneButtonClick()">
                    <span class="material-icons">
                        local_phone
                      </span>
                      <p>
                        {{ textPhoneSac }}
                      </p>
                </a>
              </div>
          </div>
      </div>
      <div class="col-md-4">
          <div class="title-phone">
              Ouvidoria
          </div>

          <div class="box-phone">
            <a href="tel:08008801999" target="_blank" (click)="onPhoneOuvidoria()">
                <span class="material-icons">
                    local_phone
                  </span>
                  <p>
                    {{ textPhoneOuvidoria }}
                  </p>
            </a>
          </div>
      </div>
    </div>
<!--
    <div class="box-content">
        <img src="../../../assets/image/line.png" alt="Linha">
        <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sem pretium molestie ipsum, ipsum.
            Tellus mauris amet, iaculis a, a, id consectetur in pellentesque. Odio amet ultricies at
            cursus nunc tortor mi velit, pellentesque. A dapibus purus ac nisl, eget euismod nullam
            aliquet lobortis. Ut non euismod urna nullam sed. Praesent posuere sit ultrices vel vulputate
            et parturient malesuada. Nulla facilisis sollicitudin eros vulputate blandit. Tortor volutpat
            ac nibh odio suspendisse eget augue iaculis nec. Cum integer turpis in magna adipiscing augue
            urna morbi sit. Faucibus nec leo ac diam mattis ac viverra.
        </p>
    </div>
    -->
    <app-loading></app-loading>
</footer>
